module.exports = __webpack_public_path__ + "img/Spotify_Logo.c9739105.png";